export default __webpack_public_path__ + "static/media/loaderWhite.7daf0e9e.png";